// 小程序部署类型
export enum AppDeployType {
  Independent = 1, // 独立部署
  Public = 2, // 非独立部署
}

export const APP_DEPLOY_TYPE_MAP = {
  [AppDeployType.Independent]: '独立部署',
  [AppDeployType.Public]: '公共部署',
};

// 小程序服务类型
export enum AppServerMode {
  Normal = 1, // 普通模式
  Provider = 2, // 服务商模式
}

export const APP_SERVER_MODE_MAP = {
  [AppServerMode.Normal]: '普通模式',
  [AppServerMode.Provider]: '服务商模式',
};

// 企业主体类型
export enum BusinessType {
  Enterprise = 1, // 企业/公司
  Individual = 2, // 个体工商户
}

// 企业主体类型映射
export const BUSINESS_TYPE_MAP = {
  [BusinessType.Enterprise]: '公司',
  [BusinessType.Individual]: '个体工商户',
};

// 企业主体性质列表
export const BUSINESS_TYPE_LIST = Object.entries(BUSINESS_TYPE_MAP).map(([key, label]) => ({
  label,
  value: Number(key),
}));

// 银行账户类型
export enum BankAccountType {
  Corporate = 1, // 对公账户
  PersonalLegal = 2, // 法人个人户
}

// 银行账户类型映射
export const BANK_ACCOUNT_TYPE_MAP = {
  [BankAccountType.Corporate]: '对公账户',
  [BankAccountType.PersonalLegal]: '法人个人户',
};

// 银行账户类型列表
export const BANK_ACCOUNT_TYPE_LIST = Object.entries(BANK_ACCOUNT_TYPE_MAP).map(([key, label]) => ({
  label,
  value: Number(key),
}));

// 收款账户状态
export enum PaymentAccountStatus {
  Init = 0, // 初始状态
  BindFailed = 1, // 绑定失败
  Signing = 2, // 绑定成功签约中
  PendingReview = 3, // 签约完成审核中
  Effective = 4, // 审核通过已生效
}

// 收款账户类型
export enum PaymentAccountType {
  PendingSettlement = '08', // 待结算账户
}

// 提现设置
export enum WithdrawalMode {
  Manual = 0, // 手动提现
  Auto = 1, // 自动提现
}

// 提现状态
export enum WithdrawalStatus {
  Pending = 0, // 进行中
  Success = 1, // 成功
  Failed = 2, // 失败
}

// 课程结算统计方式
export enum CourseStatisticMode {
  ByCount = 1, // 按节数统计
  ByDuration = 2, // 按时长统计
}

// 登录人角色
export enum LoginUserRole {
  Admin = 1, // 管理员
}

// oss扣费类型
export enum OssCostType {
  Upload = 1, // 上传流量费
  Storage = 2, // 存储费
  Recharge = 3, // 充值
}

// 共用余额流水业务类型
export enum MerchantBalanceFlowBizType {
  OssConsume = 'oss_consume',
  AiPosterConsume = 'ai_poster_consume',
  Recharge = 'recharge',
}

export const MERCHANT_BALANCE_FLOW_BIZ_TYPE_OPTIONS = [
  { label: '视频存储', value: MerchantBalanceFlowBizType.OssConsume },
  { label: '海报设计', value: MerchantBalanceFlowBizType.AiPosterConsume },
  { label: '充值', value: MerchantBalanceFlowBizType.Recharge },
];

// 线上课开通状态
export enum OnlineCourseStatus {
  UnActivated = 0, // 未开通
  Activating = 1, // 开通中
  Activated = 2, // 已开通
  Deactivated = 3, // 已停用
}

// 课程自动结算选项
export enum CourseAutoSettlement {
  Yes = 1, // 课程结束后第二天24点结算
  No = 2, // 不自动结算
}

// 小程序首页类型
export enum WxHomePageType {
  Course = 1, // 课表页为首页
  Independent = 2, // 独立首页
}

// 商户收款方式
export enum CollectionMethod {
  OnlineOnly = 1, // 仅在线支付
  Unlimited = 2, // 不限(线上和线下收款)
}
